import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroupDirective,
  FormsModule,
  NgForm,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { NAME_VOTE_STORE } from '../signals/+store/name-vote.store';
import { HistoryBook } from '../signals/+models/history-book.model';
import { HISTORY_BOOK_STORE } from '../signals/+store/history-book.store';
import { NwvoteService } from '../nw-vote/nwvote.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-new-name',
    imports: [
        FormsModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatIconModule,
        MatInputModule,
        MatTableModule,
        MatButtonModule,
        CommonModule,
    ],
    templateUrl: './new-name.component.html',
    styleUrls: ['./new-name.component.scss']
})
export class NewNameComponent implements OnInit { 
  suggestionForm: UntypedFormGroup;
  matcher = new class extends ErrorStateMatcher {
    isErrorState(
      control: FormControl | null,
      form: FormGroupDirective | NgForm | null
    ): boolean {
      return false;
    }
  };
  readonly nameVoteStore = inject(NAME_VOTE_STORE);
  private readonly historyBookStore = inject(HISTORY_BOOK_STORE);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly nwvoteService = inject(NwvoteService);
  private readonly snackBar = inject(MatSnackBar);

  ngOnInit(): void {
    this.suggestionForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
    });
  }

  addName(): void {
    if (this.suggestionForm.invalid) return;

    const input = this.suggestionForm.value.name.trim();
    // Split the input by comma, trim each name, and filter out empty names
    const newNames: string[] = input
      .split(',')
      .map((name: string) => name.trim())
      .filter((name: string) => name.length > 0);

    if (newNames.length === 0) return;

    // Remove duplicates
    const uniqueNames = [...new Set(newNames)];

    this.nameVoteStore.addNewNamesVoters({
      email: localStorage.getItem('username'),
      newNames: uniqueNames,
    });

    const historyData: HistoryBook = {
      date: new Date().toLocaleDateString(),
      time: new Date().toLocaleTimeString(),
      action: 'Added',
      content: JSON.stringify({
        'For Name': this.nameVoteStore.name(),
        'Suggested name(s)': uniqueNames,
      }),
    };
    this.historyBookStore.addHistory(historyData);

    this.nwvoteService.newNamesSuggestions(this.nameVoteStore.name(), uniqueNames).subscribe({
      next: (response) => {
        this.snackBar.open('Your names were saved!', '', {
          duration: 3000, 
        });

        this.nameVoteStore.clearNewNamesVotersInfo();
      },
      error: (err) => {
        console.error('Error saving names:', err);
        this.snackBar.open('Failed to save names. Please try again.', '', {
          duration: 3000,
        });
      },
    });

    this.suggestionForm.reset({ name: '' });
  }
}
